module.exports = __webpack_public_path__ + "img/benefit_premier-cfp_pre-game-tailgate.c6ee75af.jpg";